import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import apiUser from "../../../apiUser";
import Button from "../../Button";

import {ListGroup, ListGroupItem} from "reactstrap";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const Diagnostic = props => {
  const {getApiPrimaryParams, setPrintData, unsetPrintData} = useTecRmi()
  const [manual, setManual] = useState(null)
  const [manualHtml, setManualHtml] = useState()

  useEffect(() => () => unsetPrintData(), [])

  useDidMountEffect(() => {
    if(props.itemMp.Manuals.length === 1){
      setManual(props.itemMp.Manuals[0])
    }
  })

  useAfterUpdateEffect(() => {
    if(manual){
      const params = {
        ...getApiPrimaryParams(),
        itemMpId: props.itemMp.ItemMpId,
        componentTypeId: props.componentTypeId,
        qualColId: manual.QualColId,
        systemQualColId: manual.SystemQualColId,
        printView: false,
        kindOfWorkTime: 0,
        linkUrl: '',
      }

      setPrintData(apiUser.tecRmi.diagnostics.manualHtmlPrint, {
        ...params,
        printView: true,
      })

      apiUser.tecRmi.diagnostics.manualHtml(params)
        .then(res => setManualHtml(res.data[0]))
    }else{
      setManualHtml(null)
    }
  }, [manual])

  return (
    <div>
      {props.itemMp.Manuals.length > 1 && <React.Fragment>
        {
          manual
            ? <Button disabled={!manualHtml} color={'light'} size={'sm'} onClick={() => setManual(null)}>
              <i className="fas fa-arrow-left" />
              <span>Wróć</span>
            </Button>
            : <ListGroup>
              {props.itemMp.Manuals.map(manual => <ListGroupItem className="cursor-pointer" onClick={() => setManual(manual)}>{manual.QualColText} {manual.SystemQualColText}</ListGroupItem>)}
            </ListGroup>
        }
      </React.Fragment>}

      {manual && (
        manualHtml
          ? <div dangerouslySetInnerHTML={{__html: manualHtml}} />
          : <LoadingSpinner />
      )}
    </div>
  );
};

Diagnostic.propTypes = {
  componentTypeId: PropTypes.number.isRequired,
  itemMp: PropTypes.shape({
    ItemMpId: PropTypes.number.isRequired,
    ItemMpText: PropTypes.string.isRequired,
    Manuals: PropTypes.arrayOf(PropTypes.shape({
      QualColId: PropTypes.number.isRequired,
      QualColText: PropTypes.string.isRequired,
    }),).isRequired,
  }).isRequired,
};

export default Diagnostic;